import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M36.6096 83.9064C37.4813 82.9744 43.1265 77.0648 46.2987 61.7357C49.0858 48.7367 50.9406 24.1863 45.5183 13.3389C43.5984 9.62753 40.6645 6.50957 37.0423 4.33136C33.4202 2.15316 29.2517 1 25 1C20.7483 1 16.5798 2.15316 12.9577 4.33136C9.33555 6.50957 6.40156 9.62753 4.48168 13.3389C-0.940548 24.1863 0.914139 48.7367 3.70127 61.7357C6.87353 77.0648 12.5086 82.9744 13.3802 83.9064C14.9207 85.5623 19.674 87 25.0152 87C30.3563 87 35.0995 85.5524 36.6096 83.9064Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
  )
}
